import { Navigate, useParams, useLocation } from "@/lib/router-compat";

/** Redirects /en/blog/author/:slug → /en/author/:slug */
const BlogAuthorRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/en/author/${slug}`} replace />;
};

/** Redirects /en/case-study/:slug → /en/case-studies/:slug */
export const CaseStudyRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/en/case-studies/${slug}`} replace />;
};

/** Redirects /regulatory-updates/* → /en/regulatory-updates/* (handles nested slashes) */
export const RegulatoryUpdateWildcardRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/regulatory-updates\//, "");
  return <Navigate to={`/en/regulatory-updates/${rest}${search}${hash}`} replace />;
};

/** Redirects /es/blog/blog/:slug → /es/blog/:slug (double-blog prefix from legacy) */
export const DoubleBlogRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/es/blog/${slug}`} replace />;
};

/** Redirects /es/regulatory-updates/* → /es/actualizaciones-regulatorias/* */
export const ESRegulatoryUpdateRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/es\/regulatory-updates\/?/, "");
  if (!rest) return <Navigate to={`/es/actualizaciones-regulatorias${search}${hash}`} replace />;
  return <Navigate to={`/es/actualizaciones-regulatorias/${rest}${search}${hash}`} replace />;
};

/**
 * Normalises paths that contain dots in slugs by stripping dots.
 * Runs early in the router to catch legacy URLs with periods.
 * e.g. /en/news/dr.-angeles → /en/news/dr-angeles
 */
export const DotSlugNormalizer = () => {
  const { pathname, search, hash } = useLocation();
  // Only act on content paths that have a slug segment containing a dot
  const contentPrefixes = [
    /^\/(en|es)\/(news|noticias)\//,
    /^\/(en|es)\/(regulatory-updates|actualizaciones-regulatorias)\//,
    /^\/(en|es)\/case-studies?\//,
    /^\/(en|es)\/blog\//,
    /^\/(en)\/(resources\/company-news)\//,
  ];
  const matchesContent = contentPrefixes.some((re) => re.test(pathname));
  if (!matchesContent) return null;

  // Strip dots from the slug portion only
  const normalized = pathname.replace(/\.(?=[^/])/g, "");
  if (normalized === pathname) return null;

  return <Navigate to={`${normalized}${search}${hash}`} replace />;
};

/** Redirects /es/casos-de-estudio/:slug → /es/casos-de-exito/:slug */
export const CasosDeEstudioSlugRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/es/casos-de-exito/${slug}`} replace />;
};

/** Redirects /blog/:slug → /en/blog/:slug */
export const BlogRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/en/blog/${slug}`} replace />;
};

/** Redirects /(es|zh-cn)/author/:slug → /en/author/:slug (authors are centralised in English) */
export const AuthorRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/en/author/${slug}`} replace />;
};

export default BlogAuthorRedirect;
